<template>
    <div class="bg--white w-100 h-100">
        <div class="w-100">
            <div class="cs__wrap">
                <h1 class="cs__heading">
                    Coming soon
                </h1>
                <p class="cs__text">
                    This feature isn't available yet.
                </p>
            </div>
        </div>
    </div>
</template>
  
<script>  
export default {
    name: "ComingSoon",
};
</script>
  
  <style lang="scss" scoped>
    .home {
      height: 100%;
    }

    .cs {
        &__wrap {
            padding: 70px;
            // margin-top: 40px;
            border: 2px dotted #b4a9c8;
            text-align: center;
                border-radius: 10px;
        } 

        &__heading {
            font-size: 1.75rem;
            color: #42526e;
            margin-bottom: 0;
            font-weight: 600;
        }

        &__text {
            font-size: 1.25rem;
            color: #42526e;
            opacity: 70%;
        }
    }
  </style>
  